import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { CodeBlock } from '@/components/docs/CodeBlock';

export default function InstallationPage() {
  return (
    <article className="max-w-3xl" data-testid="docs-installation">
      <h1 className="text-3xl sm:text-4xl font-bold tracking-tight mb-4">Installation</h1>
      <p className="text-base text-white/50 leading-relaxed mb-8">Install GhostLayout in your React or Next.js project.</p>

      <h2 className="text-xl font-bold tracking-tight mb-4">Packages</h2>
      <div className="border border-white/[0.06] rounded-lg bg-[#0A0A0A] p-5 mb-6">
        <table className="w-full text-sm">
          <thead><tr className="text-left text-white/30"><th className="pb-3 font-mono text-xs">Package</th><th className="pb-3 font-mono text-xs">Purpose</th></tr></thead>
          <tbody className="text-white/60">
            <tr className="border-t border-white/[0.04]"><td className="py-2.5 font-mono text-xs">@ghostlayout/react</td><td className="py-2.5 text-xs">Skeleton component, renderer, animations</td></tr>
            <tr className="border-t border-white/[0.04]"><td className="py-2.5 font-mono text-xs">@ghostlayout/cli</td><td className="py-2.5 text-xs">CLI tool for bone generation (dev dependency)</td></tr>
            <tr className="border-t border-white/[0.04]"><td className="py-2.5 font-mono text-xs">@ghostlayout/core</td><td className="py-2.5 text-xs">Installed automatically as a dependency</td></tr>
          </tbody>
        </table>
      </div>

      <h2 className="text-xl font-bold tracking-tight mb-4 mt-10">npm</h2>
      <CodeBlock language="bash" code={`npm install @ghostlayout/react\nnpm install -D @ghostlayout/cli`} />

      <h2 className="text-xl font-bold tracking-tight mb-4 mt-10">yarn</h2>
      <CodeBlock language="bash" code={`yarn add @ghostlayout/react\nyarn add -D @ghostlayout/cli`} />

      <h2 className="text-xl font-bold tracking-tight mb-4 mt-10">pnpm</h2>
      <CodeBlock language="bash" code={`pnpm add @ghostlayout/react\npnpm add -D @ghostlayout/cli`} />

      <h2 className="text-xl font-bold tracking-tight mb-4 mt-10">Playwright browsers</h2>
      <p className="text-sm text-white/40 mb-4 leading-relaxed">The CLI uses Playwright to visit your app. On first run, install the browser:</p>
      <CodeBlock language="bash" code={`npx playwright install chromium`} />

      <div className="mt-10 flex gap-3">
        <Link to="/docs/quick-start" className="inline-flex items-center gap-2 bg-white text-black px-4 py-2 rounded-md text-sm font-semibold hover:bg-gray-200 transition-colors" data-testid="next-quickstart-btn">
          Quick Start <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
    </article>
  );
}
